
export const isPlaceholder = () => {
  const hostname = window.location.hostname
  return /(localhost|cyangecko\.com)/.test(hostname)
}
